import React,{useEffect,useState} from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import LoginForm from './login-form'
import {Redirect} from 'react-router-dom'
function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      Copyright © 2020 &nbsp;
      <Link target="_blank" color="brown" href="https://www.reliablekota.com">
      Reliable Institute Kota
      </Link>
       . All Rights Reserved

    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: 'url(https://reliablekota.com/images/bg/reliable-bg.jpg)',
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function SignInSide() {
  const classes = useStyles();
  const [login, setLogin] = useState(false);
  useEffect(() => {
  const token=localStorage.getItem("aptitude_test_token");
  if(token)
  setLogin(true)


     },[]
  );
  if(login)
  return(
  <Redirect to="/aptitude-test-result/dashboard"/>
  )






  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={8} className={classes.image} />
      <Grid item xs={12} sm={8} md={4} component={Paper} elevation={6} square>
        <div className={classes.paper}>
           <img src={`https://www.reliablekota.com/images/logo.png`} style={{ width: 160 }} />
<br />
             <Typography variant="h6" color="textSecondary" align="center">

APTITUDE TEST Result
</Typography>

            <LoginForm classes={classes}/>

            <Box mt={5}>
               <Copyright />
            </Box>

        </div>
      </Grid>
    </Grid>
  );
}
